import { handleChatConnected } from './handleChatConnected'
import { handleChatCustomerId } from './handleChatCustomerId'
import { handleChatDeactivated } from './handleChatDeactivated'
import { handleChatDisconnected } from './handleChatDisconnected'
import { handleChatIcomingChat } from './handleChatIncomingChat'
import { handleChatIncomingEvent } from './handleChatIncomingEvent'
import { handleChatUserData } from './handleChatUserData'

/**
 *
 * @param {import('@livechat/customer-sdk').CustomerSDK} instance
 * @param {Record<string, any>} [chatParams] - Optional chat params to pass to handleChatConnected
 */
export function setupChatEventsHandlers(instance, chatParams) {
  instance.on('connected', (payload) => {
    handleChatConnected(
      instance,
      /** @type {LCChatConnectedEvent} */ (payload),
      chatParams,
    )
  })

  instance.on('disconnected', (payload) => {
    handleChatDisconnected(/** @type {LCChatDisconnectedEvent} */ (payload))
  })

  instance.on('chat_deactivated', (payload) => {
    handleChatDeactivated(/** @type {LCChatDeactivatedEvent} */ (payload))
  })

  instance.on('customer_id', (payload) => {
    handleChatCustomerId(/** @type {string} */ (payload))
  })

  instance.on('user_data', (payload) => {
    handleChatUserData(/** @type {LCChatUser} */ (payload))
  })

  instance.on('incoming_event', (payload) => {
    handleChatIncomingEvent(/** @type {LCChatIncomingEvent} */ (payload))
  })

  instance.on('incoming_chat', (payload) => {
    handleChatIcomingChat(/** @type {LCChatIncomingChatEvent} */ (payload))
  })
}
